var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"myDiv"}}),_c('div',{staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"testmap"}})])
}]

export { render, staticRenderFns }